import { Type } from 'class-transformer';
import { WFEBudgetedGLAccountSelectorResultDto } from '../../shared-workflow-module/_models/wfe-budgeted-gl-account-selector-result-dto';
import { DimensionSelectorResultDto } from '../../cirabooks/shared-cirabooks-module/_models/common/dimensions/dimension-selector-result-dto';

export class PaymentRequestCodingEditorResultDto {
    hasVendorNotes: boolean;
    allowEditDimension: boolean;

    @Type(() => WFEBudgetedGLAccountSelectorResultDto)
    glAccounts: Array<WFEBudgetedGLAccountSelectorResultDto>;

    @Type(() => DimensionSelectorResultDto)
    dimensions: Array<DimensionSelectorResultDto>;
}
